import * as React from "react";
import { SVGProps } from "react";
const SvgInfoTertiary = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 13a1.5 1.5 0 0 1 1.5 1.5v11a1.5 1.5 0 1 1-3 0v-11A1.5 1.5 0 0 1 16 13Zm0-8a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgInfoTertiary;
